/* 
  File: C:\Users\Markus Diehl\source\Expert4Germany\src\pages\legal\Datenschutz.js
  Name: Datenschutz.js
  Zweck: Datenschutzerklärung.
*/

import React from 'react';

const Datenschutz = () => {
  return (
    <div className="p-5 text-white bg-gray-900 min-h-screen">
      <h1 className="text-3xl font-bold mb-4">Datenschutz</h1>
      <p>Hier steht die Datenschutzerklärung. (Inhalt folgt.)</p>
    </div>
  );
};

export default Datenschutz;
